"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlerts = void 0;
var context_1 = require("../../components/GKAlert/context");
var react_1 = __importDefault(require("react"));
/**
 * Returns the GKAlertContext
 *
 * @example
 * const alertCtx = useAlerts();
 * alertCtx.danger("Oh no!");
 */
var useAlerts = function () {
    return react_1.default.useContext(context_1.GKAlertContext);
};
exports.useAlerts = useAlerts;
